import { render, staticRenderFns } from "./InstructionDetail.vue?vue&type=template&id=3414ff90&scoped=true&"
import script from "./InstructionDetail.vue?vue&type=script&lang=ts&"
export * from "./InstructionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InstructionDetail.vue?vue&type=style&index=0&id=3414ff90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414ff90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
